<template>
  <pdl-button
    secondary
    block
    qaid="customization-save-button"
    :disabled="isProcessingCustomizationAction"
    @click="save"
  >
    {{ $t('text.button.save') }}
  </pdl-button>
</template>

<script>
import {PdlButton} from '@pedal/pdl-button';
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';
import {PdlToastType} from '@/constants/pdl-toast-type';
import {SUMMARY_DIALOG_VIEWS} from '@/familyDetailsPage/store/bike-customization.js';

export default {
  components: {
    PdlButton,
  },
  props: {
    watchForSave: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('backend', ['isUserLoggedIn']),
    ...mapState('bikeCustomization', [
      'bikeData',
      'hasQueuedSaveAction',
      'isCustomizationSummaryDialogOpen',
      'isProcessingCustomizationAction',
    ]),
    ...mapGetters('bikeCustomization', ['hasBikeBeenSubmittedToRetailer']),

    hasBeenSavedPreviously() {
      return this.$route.params.buildId?.includes('P-');
    },
  },
  watch: {
    bikeData: {
      handler(value) {
        //checking for saved build code
        if (this.watchForSave && value.code) {
          this.checkForQueuedSaveAction();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    if (!this.hasBeenSavedPreviously && this.watchForSave) {
      this.checkForQueuedSaveAction();
    }
  },
  methods: {
    ...mapMutations('bikeCustomization', [
      'setCachedBuildData',
      'setHasQueuedSaveAction',
      'setIsSaveDialogVisible',
      'setSummaryDialogView',
      'setReopenPreviouslyOpenDialog',
      'setIsProcessingCustomizationAction',
    ]),
    ...mapActions('bikeCustomization', ['saveConfig']),

    checkForQueuedSaveAction() {
      if (!this.hasQueuedSaveAction) return;
      if (this.isUserLoggedIn) {
        this.save();
        return;
      }
      this.setHasQueuedSaveAction(false);
    },

    async save() {
      if (!this.isUserLoggedIn) {
        this.setReopenPreviouslyOpenDialog(true);
        this.setIsProcessingCustomizationAction(true);
        this.setCachedBuildData();
        this.setHasQueuedSaveAction(true);
        await this.$nextTick();
        window.location.href = '/login/';
        return;
      }
      if (this.hasBeenSavedPreviously && !this.hasBikeBeenSubmittedToRetailer) {
        try {
          this.setIsProcessingCustomizationAction(true);
          await this.saveConfig();
        } catch (error) {
          console.error(error);
          this.$notify({
            type: PdlToastType.ERROR,
            message: this.$t('errorMessage.unableToProcess'),
          });
        } finally {
          this.setIsProcessingCustomizationAction(false);
        }
        return;
      }
      if (this.isCustomizationSummaryDialogOpen) {
        this.setSummaryDialogView(SUMMARY_DIALOG_VIEWS.SAVE_BUILD);
      } else {
        this.setIsSaveDialogVisible(true);
      }
    },
  },
};
</script>
